<template>
  <div>
    <!-- <div class="bannerW">
      <el-image
        :src="require('@/assets/img/career.jpg')"
        fit="cover"
        class="banner"
      ></el-image>
      <div class="titleBox">
        <h2>融合发展</h2>
        <p>INTEGRATED DEVELOPMENT</p>
      </div>
    </div> -->
    <Banner :classType="6" />

    <Menu />

    <!-- <div class="wrap JobAddress wow animate__slideInUp">
      <el-row :gutter="30">
        <el-col :span="8">
          <div class="itemJob">
            <i class="el-icon-location-outline"></i>
            <h3>连云港公司</h3>
            <p>
              地址：江苏省连云港市经济开发区<br />
              大浦工业区金桥路6号<br />
              联系人：李先生 司女士<br />
              联系电话：0518-86070121<br />
              邮箱：hr@zfsycf.com.cn
            </p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="itemJob">
            <i class="el-icon-location-outline"></i>
            <h3>西宁公司</h3>
            <p>
              地址：青海省西宁市西宁经济开发区<br />
              甘河工业园区甘家路2号<br />
              联系人：赵女士 李先生<br />
              联系电话：0971-2219006<br />
              邮箱：xnhr@zfsycf.com.cn
            </p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="itemJob">
            <i class="el-icon-location-outline"></i>
            <h3>上海公司</h3>
            <p>
              地址：上海自由贸易试验区临港新片区<br />
              盛路188号<br />
              联系人：李先生 刘女士<br />
              联系电话：0518-86070121
            </p>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <div class="pageTitle wow animate__slideInUp">
      <h2>人才招聘</h2>
      <p>JOIN US</p>
    </div>
    <Company />

    <div class="pageTitle wow animate__slideInUp">
      <h2>人才招聘</h2>
      <p>JOIN US</p>
    </div>

    <ul class="myTabs2 wow animate__slideInUp">
      <!-- <li>连云港公司</li>
      <li>西宁公司</li>
      <li>上海公司</li> -->
      <li
        :key="idx"
        :class="{ current: newsOn == item.Id }"
        v-for="(item, idx) in contactList" 
        @click="newsTabFn(item.Id)"
      >
        {{ item.Name }}
      </li>
    </ul>

    <div class="wrap wow animate__slideInUp jobListBox">
      <div class="search2 flex-cb">
        <input
          v-model="keyWord"
          @input="getNewsList(1)"
          placeholder="请输入职位关键词"
        />
        <button><i class="el-icon-search"></i>职位搜索</button>
      </div>
      <el-row class="jobTop">
        <el-col :span="2"><span class="jobPD">序号</span></el-col>
        <el-col :span="4">岗位名称</el-col>
        <el-col :span="4">部门</el-col>
        <el-col :span="2">人数</el-col>
        <el-col :span="4">学历要求</el-col>
        <el-col :span="6">专业类别</el-col>
        <el-col :span="2"></el-col>
      </el-row>

      <el-collapse accordion class="jobCol">
        <el-collapse-item :key="idx" v-for="(item, idx) in jobList">
          <template slot="title">
            <el-row class="jobTitle">
              <el-col :span="2"
                ><span class="jobPD">{{
                  idx + 1 + 8 * (currentPage - 1)
                }}</span></el-col
              >
              <el-col :span="4">{{ item.PositionName }}</el-col>
              <el-col :span="4">{{ item.Department }}</el-col>
              <el-col :span="2">{{ item.Number }}</el-col>
              <el-col :span="4">{{ item.Education }}</el-col>
              <el-col :span="6">{{ item.Major }}</el-col>
              <el-col :span="2"><span class="jobOpen">职位详情</span></el-col>
            </el-row>
          </template>
          <el-row :gutter="20" class="jobDetail">
            <el-col :span="12">
              <h4>工作内容</h4>
              <p v-html="changeValue(item.WorkContent)"></p>
              <div>
                <a :href="item.SubmitResumeUrl" target="_blank"
                  ><span class="bigMore greyBtn">投递简历</span></a
                >
              </div>
            </el-col>
            <el-col :span="12"
              ><h4>任职资格</h4>
              <p v-html="changeValue(item.Qualifications)"></p>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="pageBox">
      <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Pagination from "@/views/components/Pagenation";
import Company from "@/views/components/Company";
import { WOW } from "wowjs";
import { changeText } from "@/utils/tool";
import Banner from "@/views/components/Banner";

export default {
  data() {
    return {
      jobList: [],
      newsNav: ["连云港公司", "西宁公司", "上海公司"],
      newsOn: 1,
      contactList: [],
      PagingInfo: {},
      currentPage: 1,
      keyWord: "",
      showPage:false
    };
  },
  components: {
    Menu,
    Pagination,
    Company,
    Banner,
  },
  methods: {
    changeValue(value) {
      return changeText(value);
    },
    newsTabFn(idx) {
      if (this.newsOn != idx) {
        this.newsOn = idx;
        this.getNewsList(1);
      }
    },
    getNewsList(page, type) {
      sessionStorage.setItem("keyWord", this.keyWord);
      this.currentPage = page;
      this.$api
        .job({
          Key: this.keyWord,
          CompanyId: this.newsOn,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { JobInfos, PagingInfo } = res.Value;
          if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
          this.jobList = JobInfos;
          this.PagingInfo = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
  },
  mounted() {
    this.$api
      .contact({
        Type: 2,
      })
      .then((res) => {
        const { CompanyInfos } = res.Value;
        this.contactList = CompanyInfos;
        this.newsOn = this.contactList[0].Id;
        this.getNewsList(1, "first");
      });
  },
};
</script>

<style lang="scss">
.JobAddress {
  padding: 50px 0;
}
.itemJob {
  min-height: 380px;
  padding: 30px 0;
  margin-bottom:30px;
  border: 1px solid #ddd;
  text-align: center;
  i {
    font-size: 60px;
  }
  h3 {
    font-size: 24px;
    padding: 20px 0;
  }
  p {
    line-height: 30px;
    font-size: 16px;
  }
}

.jobTabs {
  text-align: center;
  padding: 30px 0;
  li {
    display: inline-block;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    line-height: 35px;
    margin: 0 20px;
    font-size: 23px;
    &:hover {
      border-bottom: 2px solid #d71820;
    }
  }
}
.jobTop {
  font-size: 16px;
  width: 100%;
  color: #000;
  font-weight: 400;
  background: #f9f9f9;
  padding: 30px 25px 30px 0;
  .el-col {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.jobTitle {
  width: 100%;
}
.jobDetail {
  background: #f9f9f9;
  padding: 20px;
  h4 {
    font-size: 16px;
    padding: 0 0 10px 0;
  }
  p {
    padding: 0 0 20px 0;
  }
}
.jobOpen:hover {
  color: #d71820;
}
.el-collapse-item__header {
  font-weight: normal !important;
}
.el-collapse-item:hover,
.el-collapse-item.is-active {
  .el-collapse-item__header {
    background: #f9f9f9;
  }
  .jobOpen {
    color: #d71820;
  }
}

.jobCol {
  margin: 0 0 0px 0;
}
.jobPD {
  padding-left: 10px;
}
.search2 {
  margin: 25px 0;
  input {
    flex: 1;
    height: 50px;
    line-height: 50px;
    border: 1px solid #999898;
    padding: 0 15px;
    outline: 0;
  }
  button {
    width: 150px;
    height: 50px;
    border: 0;
    outline: 0;
    color: #fff;
    background: #c6312c;
    cursor: pointer;
    i {
      font-size: 16px;
      margin-right: 10px;
    }
    &:hover {
      opacity: 0.88;
    }
  }
}
@media (max-width:768px) {
  .search2 button{
    width:100px;
  } 
}
</style>
